import { gql } from '@apollo/client';
import PrivateEventFragments from '../fragments/privateEvent.fragments';

const PLACE_PRIVATE_EVENT_BID = gql`
  mutation PlacePrivateEventBid($params: PlacePrivateEventBidParams!) {
    placePrivateEventBid(params: $params) {
      ...PrivateEventFields
      ...PrivateEventPSAFiles
      ...PrivateEventParticipants
      ...PrivateEventBids
      ...PrivateEventSettings
      ...PrivateEventContingencies
      ...PrivateEventMeta
      ...PrivateEventListing 
    }
  }

  ${PrivateEventFragments.fields}
  ${PrivateEventFragments.psaFiles}
  ${PrivateEventFragments.participants}
  ${PrivateEventFragments.bids}
  ${PrivateEventFragments.settings}
  ${PrivateEventFragments.contingencies}
  ${PrivateEventFragments.meta}
  ${PrivateEventFragments.listing}
`;

export default PLACE_PRIVATE_EVENT_BID;
